export default "__VITE_ASSET__DJotS3K5__"